"use client";

import { OnboardingItemLayout } from "@/components/Onboarding/components/OnboardingItemLayout";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Action,
  ControlType,
  useOnboardingAnalytics,
} from "@/context/AnalyticsProvider";
import { useOnboardingStep } from "@/context/OnboardingStepProvider/OnboardingStepProvider";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import { useEffect, useRef } from "react";
import { OnboardingStep, type OnboardingStepProps } from "../constants";

export const FreeEntryInfo = ({ visible }: OnboardingStepProps) => {
  const { goToNextStep } = useOnboardingStep();
  const { track } = useOnboardingAnalytics();
  const { currentStep } = useOnboardingStep();
  const hasViewedRef = useRef(false);

  useEffect(() => {
    if (hasViewedRef.current || !visible) return;
    hasViewedRef.current = true;

    track({
      action: Action.VIEWED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_INFO,
        step: currentStep,
      },
    });
  }, [track, visible, currentStep]);

  const handleButtonClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_INFO,
        step: currentStep,
        control: "next-step",
        controlType: ControlType.BUTTON,
      },
    });

    goToNextStep();
  };

  const handleImageClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_INFO,
        step: currentStep,
        control: "onboarding-progress-bar",
        controlType: ControlType.IMAGE,
      },
    });
  };
  return (
    <OnboardingItemLayout>
      <div className="space-y-3">
        <h1 className="font-bold text-[clamp(1.5rem,4.25dvh,1.875rem)] leading-[clamp(1.875rem,5dvh,2.25rem)] text-center">
          You've got <br />
          <span className="imx-gradient">1x FREE entry to</span>
          <br /> this week's draw.
        </h1>
        <Badge className="frost-badge text-[0.625rem] leading-[0.875rem] font-bold px-4 py-2 tracking-widest text-black">
          LAST WEEK'S WINNER: 1,000IMX ~$600USD
        </Badge>
      </div>
      <Image
        src="/images/onboarding/onboarding_progress.webp"
        alt="Onboarding progress bar"
        onClick={handleImageClick}
        width={366}
        height={141}
      />
      <Button
        size="lg"
        className="w-full rounded-full py-4 text-base font-semibold relative"
        onClick={handleButtonClick}
      >
        Start onboarding
        <ArrowRight className="absolute size-5 right-4" strokeWidth={3.5} />
      </Button>
    </OnboardingItemLayout>
  );
};
